import React from "react";
import NavbarComponent from "components/Navbar";
import Footer from "components/Footer";
import { Paragraph, Title } from "components/Text";
import { ThemeProvider } from "styled-components";
import { useSelector } from "react-redux";
import { Button } from "components/Button/Button.styled";
import { Layout } from "components/Layout/Layout.styled";

const NotFound = () => {
  const theme = useSelector((state: any) => state.persistedThemeReducer);

  return (
    <ThemeProvider theme={theme}>
      <Layout className="center">
        <NavbarComponent />
        <div
          className="container text-center my-5 page-content justify-center align-items-center d-flex flex-column"
          style={{ height: "50vh" }}
        >
          <i
            className="cl cl-search mr-2"
            style={{ fontSize: "20vh" }}
          ></i>
          <Title>404 - Página no Encontrada!</Title>
          <Paragraph>Lo sentimos, la pagina que buscas no existe!</Paragraph>
          <Button
            className="btn"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Volver al inicio
          </Button>
        </div>
        <Footer />
      </Layout>
    </ThemeProvider>
  );
};

export default NotFound;
